import { render, staticRenderFns } from "./ClaimFillingActivitySection.vue?vue&type=template&id=0f9d9ad6"
import script from "./ClaimFillingActivitySection.vue?vue&type=script&lang=ts"
export * from "./ClaimFillingActivitySection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports